import { atom } from 'jotai';

export const menuTab = ['주문관리', '배송지관리', '차량관리'];

export const menuTabIndexAtom = atom<number>(0);
